import React, { Fragment, ReactNode } from 'react'
import { ElementList } from '../../ElementList/ElementList'
import { WarehouseElement } from './WarehouseElement'
import { Select } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'
import { NoRows } from '../../ElementList/NoRows'

interface WarehouseListProps {
  warehouseList: Warehouse[]
  pageSize: number
  handlePageSize: (
    event: SelectChangeEvent<number>,
    child: ReactNode
  ) => void
  handleEdit: (param: Warehouse) => void
  handleDelete: (idForDelete: number | undefined) => void
  handleView: (viewId: number) => void
}

export const WarehouseList: React.FC<WarehouseListProps> = ({
  warehouseList,
  pageSize,
  handlePageSize,
  handleEdit,
  handleDelete,
  handleView
}) => {
  return (
    <Fragment>
      <ElementList items={warehouseList} dir='vertical'>
        {(item) => (
          <WarehouseElement
            element={item}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
          />
        )}
      </ElementList>
      {warehouseList.length <= 0 && <NoRows />}
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 10 }}>
        <Select
          native
          value={pageSize}
          onChange={handlePageSize}
          style={{ alignSelf: 'flex-end' }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
        </Select>
      </div>
    </Fragment>
  )
}
